import DateTimeOptions from './DateTimeOptions';
import TimeZoneDetector from './TimeZoneDetector';
import { format, toZonedTime, fromZonedTime } from 'date-fns-tz'
import { zhCN, enUS, ja } from 'date-fns/locale';
import { parse } from 'date-fns';

class DateTime {
    
    baseValue: string = "";
    dateValue: Date;
    ignoreTime: boolean = true;
    formatWithTimezone: boolean = true;
    forceShowSeconds: boolean = true;
    overrideDateFormat: string = "";
    constructor(options: DateTimeOptions) {
        
        var that = this;

        var d = new Date();

        if (options.date) {
            d = new Date(options.date);
        }

        if (options.dateOptions) {
            if (options.dateOptions.format) {
                this.overrideDateFormat = options.dateOptions.format;
            }
            d.setFullYear(options.dateOptions.year, options.dateOptions.month, options.dateOptions.day);
            this.ignoreTime = false;
        }

        if (options.timeOptions) {
            d.setHours(options.timeOptions.hour, options.timeOptions.minute, options.timeOptions.second);
            this.ignoreTime = true;
        }

        if (options.ignoreTime != undefined) {
            this.ignoreTime = options.ignoreTime;
        }

        if (options.convertToTimezone != undefined) {
            this.formatWithTimezone = options.convertToTimezone;
        }

        this.forceShowSeconds = options.forceShowSeconds;

        this.dateValue = d;
        
        this.toString = function () {
            if (that.ignoreTime) {
                return that.toDateString();
            }
            else {
                return that.toDateString() + " " + that.toTimeString();
            }
        };
    }

    toDateString() {

        if (this.formatWithTimezone) {

            return format(toZonedTime(this.dateValue, DateTime.getTimezone()), this.overrideDateFormat == "" ? InovxLoader.getLocaleData().datePattern : this.overrideDateFormat, { timeZone: DateTime.getTimezone(), locale: DateTime.getCulture() });
        }
        else {

            return format(this.dateValue, this.overrideDateFormat == "" ? InovxLoader.getLocaleData().datePattern : this.overrideDateFormat, { locale: DateTime.getCulture()});
        }
    }

    toTimeString() {
        
        if (this.formatWithTimezone) {
            return format(toZonedTime(this.dateValue, DateTime.getTimezone()), DateTime.getTimeFormat(this.forceShowSeconds), { timeZone: DateTime.getTimezone(), locale: DateTime.getCulture() });
        }
        else {
            return format(this.dateValue, DateTime.getTimeFormat(this.forceShowSeconds), { locale: DateTime.getCulture() });
        }
    }

    toISOString() {
        return fromZonedTime(this.dateValue, DateTime.getTimezone()).toISOString();
    }

    static getLocaleTimeFormat() {
        return InovxLoader.getLocaleData().timePattern;
    }

    static utcTimeZone: string = 'Etc/UTC';

    static convertTimeFormats(time: string, options: { srcTimeFormat?: string, dstTimeFormat?: string, srcTimeZone?: string, dstTimeZone?: string }) {
        let fmtSrc = (options.srcTimeFormat) ? options.srcTimeFormat : InovxLoader.getLocaleData().timePattern;
        let fmtDst = (options.dstTimeFormat) ? options.dstTimeFormat : InovxLoader.getLocaleData().timePattern;

        let locale = this.getCulture();
        let dt = parse(time, fmtSrc, new Date(), { locale: locale });
        let formatOptions = { locale: locale, timeZone: null as string };

        if (options.srcTimeZone || options.dstTimeZone) {
            let tzSrc = (options.srcTimeZone) ? options.srcTimeZone : DateTime.getTimezone();
            let tzDst = (options.dstTimeZone) ? options.dstTimeZone : DateTime.getTimezone();

            dt = toZonedTime(dt, tzSrc);
            dt = fromZonedTime(dt, tzDst);
        }

        return format(dt, fmtDst, formatOptions);
    }

    static getLocalTimezone() {
        return (Intl.DateTimeFormat().resolvedOptions().timeZone)
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : TimeZoneDetector.guess(false);
    }

    static getTimezone() {
        return InovxLoader.getLocaleData().tz == "" ? this.getLocalTimezone() : InovxLoader.getLocaleData().tz;
    }
    static getTimeFormat(forceShowSeconds: boolean) {
        if (((InovxLoader.getLocaleData().timePattern as string).indexOf('ss') == -1) && forceShowSeconds) {
            var pattern = InovxLoader.getLocaleData().timePattern as string;
            var patternWithSeconds = pattern.slice(0, pattern.indexOf('mm') + 2) + ':ss' + pattern.slice(pattern.indexOf('mm') + 2);

            return patternWithSeconds;
        }
        else {
            return InovxLoader.getLocaleData().timePattern;
        }
    }
    static getCulture() {

        switch (InovxLoader.getLocaleData().lng) {
            case 'zh-hans':
                {
                    return zhCN;
                }
            case 'en-us':
                {
                    return enUS;
                }
            case 'ja-jp':
                {
                    return ja;
                }
            default:
                {
                    return enUS;
                }
        }
    }
}


export default DateTime;